/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentDraftsControllerDownloadQueryResponse, DocumentDraftsControllerDownloadPathParams, DocumentDraftsControllerDownloadQueryParams, DocumentDraftsControllerDownload400, DocumentDraftsControllerDownload401, DocumentDraftsControllerDownload403, DocumentDraftsControllerDownload404 } from "../../models/documentDraftsController/DocumentDraftsControllerDownload";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentDraftsControllerDownload } from "../../clients/document-draftsService/documentDraftsControllerDownload";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentDraftsControllerDownloadQueryKey = (threadId: DocumentDraftsControllerDownloadPathParams["threadId"], version: DocumentDraftsControllerDownloadPathParams["version"], params: DocumentDraftsControllerDownloadQueryParams) => [{
  url: '/api/v1/document-drafts/:threadId/versions/:version/download',
  params: {
    threadId: threadId,
    version: version
  }
}, ...(params ? [params] : [])] as const;
export type DocumentDraftsControllerDownloadQueryKey = ReturnType<typeof documentDraftsControllerDownloadQueryKey>;
export function documentDraftsControllerDownloadQueryOptions(threadId: DocumentDraftsControllerDownloadPathParams["threadId"], version: DocumentDraftsControllerDownloadPathParams["version"], params: DocumentDraftsControllerDownloadQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentDraftsControllerDownloadQueryKey(threadId, version, params);
  return queryOptions<DocumentDraftsControllerDownloadQueryResponse, ResponseErrorConfig<DocumentDraftsControllerDownload400 | DocumentDraftsControllerDownload401 | DocumentDraftsControllerDownload403 | DocumentDraftsControllerDownload404>, DocumentDraftsControllerDownloadQueryResponse, typeof queryKey>({
    enabled: !!(threadId && version && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentDraftsControllerDownload(threadId, version, params, config);
    }
  });
}

/**
 * {@link /api/v1/document-drafts/:threadId/versions/:version/download}
 */
export function useDocumentDraftsControllerDownload<TData = DocumentDraftsControllerDownloadQueryResponse, TQueryData = DocumentDraftsControllerDownloadQueryResponse, TQueryKey extends QueryKey = DocumentDraftsControllerDownloadQueryKey>(threadId: DocumentDraftsControllerDownloadPathParams["threadId"], version: DocumentDraftsControllerDownloadPathParams["version"], params: DocumentDraftsControllerDownloadQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentDraftsControllerDownloadQueryResponse, ResponseErrorConfig<DocumentDraftsControllerDownload400 | DocumentDraftsControllerDownload401 | DocumentDraftsControllerDownload403 | DocumentDraftsControllerDownload404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentDraftsControllerDownloadQueryKey(threadId, version, params);
  const query = useQuery({
    ...documentDraftsControllerDownloadQueryOptions(threadId, version, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentDraftsControllerDownload400 | DocumentDraftsControllerDownload401 | DocumentDraftsControllerDownload403 | DocumentDraftsControllerDownload404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}